module.exports = __webpack_public_path__ + "static/media/pay1.ae1d7893.png";